import { render, staticRenderFns } from "./EmailSentCard.vue?vue&type=template&id=52892939"
import script from "./EmailSentCard.vue?vue&type=script&lang=js"
export * from "./EmailSentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports